// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '../../../node_module_clones/recompose';

// Utils
import { getElementId } from '../../../common/elements/utils/elementPropertyUtils';
import { hasSeen } from '../../../common/users/userEducationUtil';
import { isEmpty } from '../../../common/utils/immutableHelper';
import { getRootBoardId, getUserEducation } from '../../../common/users/utils/userPropertyUtils';

// Components
import ListElement from '../../list/ListElement';
import InboxHeader from '../../inbox/InboxHeader';
import PageLoaderMain from '../../components/loaders/PageLoaderMain';
import BoardHierarchyError from '../BoardHierarchyError';
import EmptyBoardLoginToDesktopSuggestion from './hybrid/EmptyBoardLoginToDesktopSuggestion';

// Constants
import { LegacyHybridUseCase } from '../../../common/platform/platformTypes';
import { IN_LIST_MODE } from '../../../common/inList/listTypes';
import { ONBOARDING_EDUCATION_CODES } from '../../../common/users/userEducationConstants';

// Styles
import './MobileContent.scss';

const getShouldDisplayLoginToDesktopSuggestion = (legacyHybridUseCase) => {
    switch (legacyHybridUseCase) {
        case LegacyHybridUseCase.ANDROID_BOARD_LIST:
            return true;
        case LegacyHybridUseCase.IPAD_OS:
        default:
            return false;
    }
};

const MobileContent = (props) => {
    const {
        orderedElements,
        currentUser,
        inboxElements,
        currentBoardId,
        gridSize,
        isEditable,
        isCurrentBoardFetching,
        isCurrentBoardFetched,
        isHierarchicalBoardError,
        permissions,
        legacyHybridUseCase,
    } = props;

    if (isHierarchicalBoardError) return <BoardHierarchyError currentBoardId={currentBoardId} />;

    if (isCurrentBoardFetching && !isCurrentBoardFetched) return <PageLoaderMain />;

    if (
        getShouldDisplayLoginToDesktopSuggestion(legacyHybridUseCase) &&
        isEmpty(orderedElements) &&
        isEmpty(inboxElements) &&
        currentUser &&
        getRootBoardId(currentUser) == currentBoardId &&
        !hasSeen(getUserEducation(currentUser), ONBOARDING_EDUCATION_CODES.DESKTOP_ONBOARDING)
    ) {
        return <EmptyBoardLoginToDesktopSuggestion />;
    }

    return (
        <div className="MobileContent">
            {orderedElements.map((element) => (
                <ListElement
                    element={element}
                    key={getElementId(element)}
                    elementId={getElementId(element)}
                    currentBoardId={currentBoardId}
                    inList={IN_LIST_MODE.IN_LIST_DOCUMENT_MODE}
                    inListClass={IN_LIST_MODE.IN_LIST_DOCUMENT_MODE}
                    gridSize={gridSize}
                    isEditable={isEditable}
                    permissions={permissions}
                    documentMode
                />
            ))}

            {inboxElements.size ? <InboxHeader /> : null}

            {inboxElements.map((element) => (
                <ListElement
                    element={element}
                    elementId={getElementId(element)}
                    key={getElementId(element)}
                    currentBoardId={currentBoardId}
                    inList={IN_LIST_MODE.IN_LIST_DOCUMENT_MODE}
                    gridSize={gridSize}
                    isEditable={isEditable}
                    permissions={permissions}
                    documentMode
                />
            ))}
        </div>
    );
};

MobileContent.propTypes = {
    currentBoardId: PropTypes.string.isRequired,
    currentUser: PropTypes.object,
    orderedElements: PropTypes.array,
    inboxElements: PropTypes.object,
    permissions: PropTypes.number,
    gridSize: PropTypes.number,
    isEditable: PropTypes.bool,
    isCurrentBoardFetching: PropTypes.bool,
    isCurrentBoardFetched: PropTypes.bool,
    isHierarchicalBoardError: PropTypes.bool,

    // Legacy - only needs to be passed in the LegacyMobileWorkspace
    legacyHybridUseCase: PropTypes.string,
};

export default pure(MobileContent);
